import { Controller } from '@hotwired/stimulus';
import { showToast } from '../lib/toast';

// Copies text to the clipboard from an action param and shows a toast.
// Usage: data-action="copy#copy" data-copy-text-param="…" data-copy-message-param="…"
export default class extends Controller {
  copy(event) {
    const { message } = event.params;
    const button = event.currentTarget;

    navigator.clipboard.writeText(this.text(button, event)).then(() => {
      if (message) showToast('success', message);
      this.flash(button);
    });
  }

  // The attribute as it was written, not the param Stimulus made of it: a param
  // whose value parses as JSON arrives as an object, and the two blocks this
  // controller copies — the MCP configuration and the bare form of the API
  // example — are exactly that. `String(object)` put "[object Object]" in the
  // clipboard.
  text(button, event) {
    const written = button.dataset.copyTextParam;

    return written === undefined ? String(event.params.text ?? '') : written;
  }

  // Transient "copied" state for the dedicated id buttons.
  flash(button) {
    if (!button.matches('.ds-copyid-btn, .ds-copyfield-btn')) return;

    clearTimeout(this.timer);
    this.copiedButton?.classList.remove('is-copied');
    this.copiedButton = button;
    button.classList.add('is-copied');
    this.timer = setTimeout(() => button.classList.remove('is-copied'), 1600);
  }
}
